import React, { Component } from 'react';

//componentes
import ControlAsistencia from './controlAsistencia'

class Index extends Component {

    render(){
        return(
            <div>
                <ControlAsistencia />
            </div>
        );
    }
}
export default Index;